import { useState } from "react";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { Button } from "@mui/material";
import CreateB2BMoneyReceipt from "../moneyReceipt/CreateB2BMoneyReceipt";
import type { IB2B_Invoice } from "../type/b2bType";

const B2BInvoiceWithMoneyReceipt = ({
	invoiceDetails,
}: {
	invoiceDetails: IB2B_Invoice;
}) => {
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	return (
		<>
			<Button onClick={() => handleOpen()}>Create MoneyReceipt</Button>
			<ModalsWrapper
				showModal={open}
				setShowModal={setOpen}
				modalData={{ title: "Create Money Receipt" }}
			>
				<CreateB2BMoneyReceipt
					invoiceDetails={invoiceDetails}
					handleClose={handleClose}
				/>
			</ModalsWrapper>
		</>
	);
};

export default B2BInvoiceWithMoneyReceipt;
